import { styled } from '~/styled'

export const DialogBackground = styled('div', {
  base: ['w-screen', 'h-screen']
})
